import * as actionTypes from '../actionTypes';

const state = {
  isLoadingGetEmailTemplates: false,
  getEmailTemplatesMessage: '',
  getEmailTemplatesFailed: '',

  isLoadingPostEmailTemplate: false,
  postEmailTemplateMessage: '',
  postEmailTemplateFailed: '',

  isLoadingPatchEmailTemplate: false,
  patchEmailTemplateMessage: '',
  patchEmailTemplateFailed: '',

  isLoadingDeleteEmailTemplate: false,
  deleteEmailTemplateMessage: '',
  deleteEmailTemplateFailed: '',
};

const initializeStates = JSON.parse(JSON.stringify(state));

function emailTemplateReducer(globalState = state, action) {
  switch (action.type) {
    case actionTypes.INITIALIZE_STATES_FULFILLED:
      return {
        ...initializeStates,
      };
    case actionTypes.GET_EMAIL_TEMPLATES_PENDING:
      return {
        ...globalState,
        isLoadingGetEmailTemplates: true,
      };
    case actionTypes.GET_EMAIL_TEMPLATES_FULFILLED:
      return {
        ...globalState,
        isLoadingGetEmailTemplates: false,
        getEmailTemplatesMessage: action.data,
        getEmailTemplatesFailed: '',
      };
    case actionTypes.GET_EMAIL_TEMPLATES_FAILURE:
      return {
        ...globalState,
        isLoadingGetEmailTemplates: false,
        getEmailTemplatesFailed: action.error,
        getEmailTemplatesMessage: '',
      };
    case actionTypes.POST_EMAIL_TEMPLATE_PENDING:
      return {
        ...globalState,
        isLoadingPostEmailTemplate: true,
      };
    case actionTypes.POST_EMAIL_TEMPLATE_FULFILLED:
      return {
        ...globalState,
        isLoadingPostEmailTemplate: false,
        postEmailTemplateMessage: action.data,
        postEmailTemplateFailed: '',
      };
    case actionTypes.POST_EMAIL_TEMPLATE_FAILURE:
      return {
        ...globalState,
        isLoadingPostEmailTemplate: false,
        postEmailTemplateMessage: '',
        postEmailTemplateFailed: action.error,
      };
    case actionTypes.PATCH_EMAIL_TEMPLATE_PENDING:
      return {
        ...globalState,
        isLoadingPatchEmailTemplate: true,
      };
    case actionTypes.PATCH_EMAIL_TEMPLATE_FULFILLED:
      return {
        ...globalState,
        isLoadingPatchEmailTemplate: false,
        patchEmailTemplateMessage: action.data,
        patchEmailTemplateFailed: '',
      };
    case actionTypes.PATCH_EMAIL_TEMPLATE_FAILURE:
      return {
        ...globalState,
        isLoadingPatchEmailTemplate: false,
        patchEmailTemplateMessage: '',
        patchEmailTemplateFailed: action.error,
      };
    case actionTypes.DELETE_EMAIL_TEMPLATE_PENDING:
      return {
        ...globalState,
        isLoadingDeleteEmailTemplate: true,
      };
    case actionTypes.DELETE_EMAIL_TEMPLATE_FULFILLED:
      return {
        ...globalState,
        isLoadingDeleteEmailTemplate: false,
        deleteEmailTemplateMessage: action.data,
        deleteEmailTemplateFailed: '',
      };
    case actionTypes.DELETE_EMAIL_TEMPLATE_FAILURE:
      return {
        ...globalState,
        isLoadingDeleteEmailTemplate: false,
        deleteEmailTemplateMessage: '',
        deleteEmailTemplateFailed: action.error,
      };
    default:
      return globalState;
  }
}

export { emailTemplateReducer as default };
